import React from 'react';
import { Link } from 'react-router-dom';
import {
  X,
  User,
  CalendarDays,
  ScrollText,
  MapPin,
  Heart,
  Settings,
  LogOut,
  ChevronRight,
} from 'lucide-react';
import { FortIcon, TempleIcon } from '../components/icons/HeritageIcons';
import { useTranslation } from '../contexts/TranslationContext';
import { useAuth } from '../contexts/AuthContext';

const MENU_LINKS = [
  { to: '/search', labelKey: 'mobile.actions.search', Icon: MapPin },
  { to: '/nearby-forts', labelKey: 'mobile.actions.nearby', Icon: MapPin },
  { to: '/events', labelKey: 'mobile.actions.events', Icon: CalendarDays },
  { to: '/heritage', labelKey: 'mobile.actions.heritage', Icon: Heart },
  { to: '/history', labelKey: 'nav.history', Icon: ScrollText },
  { to: '/wades', labelKey: 'nav.wades', Icon: FortIcon },
  { to: '/blog', labelKey: 'nav.blog', Icon: ScrollText },
  { to: '/fort-guide', labelKey: 'nav.fortGuide', Icon: TempleIcon },
  { to: '/mobile/settings', labelKey: 'mobile.settings.title', Icon: Settings },
];

export default function MobileMenuSheet({ open, onClose }) {
  const { t } = useTranslation();
  const { isAuthenticated, user, logout } = useAuth();

  if (!open) return null;

  return (
    <div className="mobile-menu-sheet" role="dialog" aria-modal="true" aria-label={t('mobile.tabs.menu')}>
      <button type="button" className="mobile-menu-sheet__backdrop" onClick={onClose} aria-label={t('mobile.close')} />
      <div className="mobile-menu-sheet__panel">
        <div className="mobile-menu-sheet__header">
          <h2 className="font-marathi font-marathi-display text-lg font-bold text-[#2a1810]">{t('mobile.tabs.menu')}</h2>
          <button type="button" className="mobile-menu-sheet__close" onClick={onClose} aria-label={t('mobile.close')}>
            <X className="h-5 w-5" />
          </button>
        </div>

        {isAuthenticated && user && (
          <Link to="/profile" className="mobile-menu-sheet__profile" onClick={onClose}>
            <User className="h-5 w-5 shrink-0 text-amber-800" />
            <span className="font-marathi truncate">{user.name || user.email}</span>
            <ChevronRight className="ml-auto h-4 w-4 text-[#5c4a3a]" />
          </Link>
        )}

        <nav className="mobile-menu-sheet__links">
          {MENU_LINKS.map(({ to, labelKey, Icon }) => (
            <Link key={to} to={to} className="mobile-menu-sheet__link" onClick={onClose}>
              <Icon className="h-5 w-5 shrink-0 text-amber-800" />
              <span className="font-marathi">{t(labelKey)}</span>
              <ChevronRight className="ml-auto h-4 w-4 text-[#5c4a3a]/60" />
            </Link>
          ))}
        </nav>

        <div className="mobile-menu-sheet__footer">
          {isAuthenticated ? (
            <button
              type="button"
              className="mobile-menu-sheet__link w-full border-0 bg-transparent"
              onClick={() => {
                logout();
                onClose();
              }}
            >
              <LogOut className="h-5 w-5 shrink-0 text-red-700" />
              <span className="font-marathi text-red-800">{t('ui.logout')}</span>
            </button>
          ) : (
            <Link to="/login" className="mobile-menu-sheet__cta font-marathi" onClick={onClose}>
              {t('nav.signIn')}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
